import client from './client'

export const getWishlist = async (params = { page: 1, limit: 10, all: true }) => {
  try {
    const queryParams = new URLSearchParams()
    if (params.page) queryParams.append('page', params.page)
    if (params.limit) queryParams.append('limit', params.limit)
    if (params.all !== undefined) queryParams.append('all', params.all)

    const { data } = await client.get(`/wishlist?${queryParams.toString()}`)
    return data
  } catch (err) {
    const { response } = err

    if (response?.data) return response.data

    return { error: err.message || err }
  }
}

export const removeFromWishlist = async wishlistId => {
  try {
    const response = await client.delete(`/wishlist/delete/${wishlistId}`)

    return response
  } catch (err) {
    const { response } = err

    if (response?.data) return response.data

    return { error: err.message || err }
  }
}

export const addToWishlist = async payload => {
  try {
    const response = await client.post(`/wishlist`, payload)

    return response
  } catch (err) {
    const { response } = err

    if (response?.data) return response.data

    return { error: err.message || err }
  }
}
